import React from 'react';
import { Box, Typography } from '@material-ui/core';
import Dialog from './Dialog';
import { Alert } from '@material-ui/lab';

const ConfirmValidateTransfer = (props) => {

    return (
        <Dialog 
            disableBackdropClick
            block={true}
            close={props.close}
            title={`Valider ${props.title}`}
            submitAction={props.handleSubmit}
            disabledSubmit={props.disabled}
            submitTitle="Valider"
        >
            <Box p={1}>
                <Typography variant="body1">{props.text || "Êtes-vous sûr de vouloir valider cette opération?"}</Typography>
            </Box>
            <Alert severity="warning">
                Après validation vous ne pourrez plus la modifier
            </Alert>
        </Dialog>   
    );
};

export default ConfirmValidateTransfer;
